import $store from '@/vuex/store.js'

// INICIA O VETOR PUSH
var vetPush = {}

export const FUN_NOTIFICATION = (titulo, mensagem, data, callbacks = {}, requestId = '', options = {}) => {
  if ('Notification' in window && navigator.serviceWorker) {
    // VERIFICA SE TEM PERMISSÃO PARA NOTIFICAÇÃO
    switch (Notification.permission) {
      // PERGUNTA SE AUTORIZADA A NOTIFICAÇÃO
      case 'default':
        Notification.requestPermission(function () { FUN_NOTIFICATION(titulo, mensagem, data, callbacks, requestId, options) }, function () { FUN_NOTIFICATION(titulo, mensagem, data, callbacks, requestId, options) })
        break

        // NOTIFICAÇÃO BLOQUEADA
      case 'denied':
        // eslint-disable-next-line
        console.error('WEB [500]: Notificação bloquada pelo usuário para este site.')
        break

      // NOTIFICAÇÃO PERMITIDA
      case 'granted':
        navigator.serviceWorker.getRegistration().then(function(sw) {
          // INICIA OS DADOS DA NOTIFICAÇÃO
          var notificacao = {}

          // SETA A TITULO DA NOTIFICAÇÃO
          if ([ '', null, undefined ].indexOf(titulo) !== -1) {
            titulo = ''
          }

          // SETA A MENSAGEM DA NOTIFICAÇÃO
          notificacao.body = ''
          if ([ '', null, undefined ].indexOf(mensagem) === -1) {
            notificacao.body = mensagem
          }

          // SETA A LOGOTIPO DA NOTIFICAÇÃO
          if ([ '', null, undefined ].indexOf(options) === -1 && Object.keys(options).length >= 1) {
            notificacao = Object.assign(options, notificacao)
          }
          
          // SETA A LOGO COMO IMAGEM
          if ([ '', null, undefined ].indexOf(notificacao.icon) !== -1) {
            notificacao.icon = $store.state.logotipo
          }

          // SETA O ID DA ABA
          if ([ '', null, undefined ].indexOf(notificacao.data) !== -1) {
            // SETA O PARAMETRO PARA NOTIFICAÇÃO
            while ([ '', null, undefined ].indexOf(requestId) !== -1 || Object.keys(vetPush).indexOf(requestId) !== -1) {
              requestId = Math.floor(Math.random() * (9999 - 1000)) + 1000
            }
            
            // SETA OS DADOS QUE SERÁ ENVIADO
            notificacao.data = {
              requestId: requestId,
              APP_ABA_ID: $store.state.APP_ABA_ID,
              origin: window.location.origin,
              link: window.location.href,
              data: {}
            }
          }

          // SETA A LOGO COMO IMAGEM
          if ([ '', null, undefined ].indexOf(data) === -1 && Object.keys(data).length >= 1) {
            notificacao.data.data = data
          }

          // SETA AS FUNÇÕES CALLBACK RECEBIDAS
          if ([ '', null, undefined ].indexOf(callbacks) === -1 && typeof callbacks === 'function') {
            callbacks.click = callbacks
          }

          // SETA OS DADOS ENVIADOS NA NOTIFICAÇÃO
          vetPush[requestId] = callbacks
          
          // REALIZA A NOTIFICAÇÃO
          sw.showNotification(titulo, notificacao)
        })
        break
    }
  } else {
    // eslint-disable-next-line
    console.error('WEB [500]: Navegador não suporta notificação push.')
  }
}

if ('Notification' in window && navigator.serviceWorker) {
  navigator.serviceWorker.onmessage = function (event) {
    // PEGA A MENSAGEM RECEBIDA
    var retorno = event.data

    // VERIFICA O EVENTO RECEBIDO
    if ([ '', null, undefined ].indexOf(vetPush[retorno.requestId]) === -1 && retorno.APP_ABA_ID === $store.state.APP_ABA_ID) {
      switch (retorno.action) {
        case 'notificationclick':
          vetPush[retorno.requestId].click(retorno.data)
          break
      }
    }
  }
} else {
  // eslint-disable-next-line
  console.error('WEB [500]: Navegador não suporta notificação push.')
}

// export const FUN_NOTIFICATION = (titulo, mensagem, data, callbacks = {}, requestId = '', options = {}) => {
//   // IMPORTA A BIBLIOTECA SE ELA AINDA NÃO FOI INICIADA
//   if ([ '', null, undefined ].indexOf(window.PushJS) !== -1) {
//     window.PushJS = require('push.js')
//   }

//   // INICIA A VARIAVEL QUE VAI SALVAR OS DADOS
//   if ([ '', null, undefined ].indexOf(window.PushJS.dados) !== -1) {
//     window.PushJS.dados = {}
//   }

//   // VERIFICA SE TEM PERMISSÃO PARA NOTIFICAÇÃO
//   switch (window.PushJS.Permission.get()) {
//     // PERGUNTA SE AUTORIZADA A NOTIFICAÇÃO
//     case 'default':
//       // SOLICITA A PERMISSÃO DE ACESSO, SE ELA AINDA NÃO FOI AUTORIZADA
//       window.PushJS.Permission.request(function () { FUN_NOTIFICATION(titulo, mensagem, data, callbacks, requestId, options) }, function () { FUN_NOTIFICATION(titulo, mensagem, data, callbacks, requestId, options) })
//       break

//       // NOTIFICAÇÃO BLOQUEADA
//     case 'denied':
//       // eslint-disable-next-line
//       console.error('WEB [500]: Notificação bloquada pelo usuário para este site.')
//       break

//     // NOTIFICAÇÃO PERMITIDA
//     case 'granted':
//       // INICIA OS DADOS DA NOTIFICAÇÃO
//       var notificacao = {}

//       // SETA A TITULO DA NOTIFICAÇÃO
//       if ([ '', null, undefined ].indexOf(titulo) !== -1) {
//         titulo = ''
//       }

//       // SETA A MENSAGEM DA NOTIFICAÇÃO
//       notificacao.body = ''
//       if ([ '', null, undefined ].indexOf(mensagem) === -1) {
//         notificacao.body = mensagem
//       }

//       // SETA O PARAMETRO PARA NOTIFICAÇÃO
//       notificacao.tag = requestId
//       if ([ '', null, undefined ].indexOf(notificacao.tag) !== -1) {
//         while (Object.keys(window.PushJS.dados).indexOf(notificacao.tag) !== -1) {
//           notificacao.tag = Math.floor(Math.random() * (9999 - 1000)) + 1000
//         }
//       }
      
//       // // SETA O TEMPO DE EXIBIÇÃO DA NOTIFICAÇÃO
//       // notificacao.timeout = 5000

//       // SETA A LOGOTIPO DA NOTIFICAÇÃO
//       if ([ '', null, undefined ].indexOf(options) === -1 && Object.keys(options).length >= 1) {
//         notificacao = Object.assign(options, notificacao)
//       }
      
//       // SETA A LOGO COMO IMAGEM
//       if ([ '', null, undefined ].indexOf(notificacao.icon) !== -1) {
//         notificacao.icon = $store.state.logotipo
//       }

//       // SETA A LOGO COMO IMAGEM
//       notificacao.data = {}
//       if ([ '', null, undefined ].indexOf(data) === -1 && Object.keys(data).length >= 1) {
//         notificacao.data = data
//       }

//       // SETA AS FUNÇÕES CALLBACK RECEBIDAS
//       if ([ '', null, undefined ].indexOf(callbacks) === -1 && typeof callbacks === 'function') {
//         callbacks.success = callbacks
//       }
      
//       // SETA AS FUNÇÕES QUE DEVE EXECUTAR
//       if ([ '', null, undefined ].indexOf(callbacks.success) === -1) {
//         notificacao.onClick = function (event) {
//           // REALIZA O FOCUS DO CAMPO
//           window.focus()

//           // EXECUTA A FUNÇÃO CALLBACK PARA O CLICK
//           callbacks.success((([ '', null, undefined ].indexOf(window.PushJS.dados[event.target.tag]) === -1) ? window.PushJS.dados[event.target.tag] : {}), event.target.tag, 'success')
//         }
//       }
//       if ([ '', null, undefined ].indexOf(callbacks.close) === -1) {
//         notificacao.onClose = function (event) {
//           callbacks.close((([ '', null, undefined ].indexOf(window.PushJS.dados[event.target.tag]) === -1) ? window.PushJS.dados[event.target.tag] : {}), event.target.tag, 'close')
//         }
//       }
//       if ([ '', null, undefined ].indexOf(callbacks.error) === -1) {
//         notificacao.onError = function (event) {
//           callbacks.error((([ '', null, undefined ].indexOf(window.PushJS.dados[event.target.tag]) === -1) ? window.PushJS.dados[event.target.tag] : {}), event.target.tag, 'error')
//         }
//       }
//       if ([ '', null, undefined ].indexOf(callbacks.show) === -1) {
//         notificacao.onShow = function (event) {
//           callbacks.show((([ '', null, undefined ].indexOf(window.PushJS.dados[event.target.tag]) === -1) ? window.PushJS.dados[event.target.tag] : {}), event.target.tag, 'show')
//         }
//       }

//       // SETA OS DADOS ENVIADOS NA NOTIFICAÇÃO
//       window.PushJS.dados[notificacao.tag] = notificacao.data
      
//       // REALIZA A NOTIFICAÇÃO
//       console.warn(window.PushJS)
//       window.PushJS.create(titulo, notificacao)
//       break
//   }
// }
